export * from './WhoWeAre';
export * from './CaseTypes';
export * from './HeroAboutUs';
export * from './OurMission';
export * from './WhyClaimMagic';
export * from './OurTeam';
export * from './Testimonial';
export * from './Awards';
export * from './Summary';
